<template>
  <el-container class="indexhome">
    
    <el-main>
      <!-- 添加小孩 -->
      <div class="rules_form">
        <!-- <p @click="back()" style="margin-bottom:18px;"><i class="icon el-icon-arrow-left"></i>{{$t('global.back')}}</p> -->
        <el-form v-if="isshow" :model="childForm"  ref="childForm" label-width="100px" class="demo-childForm">
          <!-- 添加小孩 -->
          <div class="addForm">
            <!-- <h3>{{$t('myChild.addProfile')}}</h3> -->
            <div class="addFormList">
              <!-- <p>{{$t('myChild.pickAvatar')}}</p> -->
              <img @click="chooseImg" v-if="!selectedData.url" src="../assets/Ellipse 1088.svg"  />
              <p class="changetop" v-else><img :src="selectedData.url" /><img class="editBtn" @click="chooseImg" src="../assets/111111IconColor.svg" /></p>
              <p>{{$t('myChild.childName')}}</p>
              <el-form-item prop="name">
                <el-input :class="changeFlag == 1?'':'errorPass'" type="text" v-model="childForm.name" autocomplete="off" ></el-input>
              </el-form-item>
              <p>{{$t('myChild.childBirth')}}</p>
              <el-date-picker
                v-model="childForm.birth_date"
                type="date"
                align="left"
                format="MM/dd/yyyy"
               
	              :picker-options="pickerOptions">
              </el-date-picker>
              <!-- <el-form-item prop="name">
                <el-input :class="changeBrthFlag == 1?'':'errorPass'" type="text" v-model="childForm.birthday" autocomplete="off" placeholder="MM/DD/YYYY"></el-input>
              </el-form-item> -->
            </div>
          </div>
          <el-button  type="primary" @click="toAdd()">{{$t('myChild.Next')}}</el-button>
        </el-form>
        <el-form v-else :model="editForm"  ref="childForm" label-width="100px" class="demo-childForm">
          <!-- 添加小孩 -->
          <div class="addForm">
            <h3>{{$t('myChild.editProfile')}}</h3>
            <div class="addFormList">
              <p>{{$t('myChild.pickAvatar')}}</p>
              <img :src="editForm.avatar" /><img class="editBtn" @click="chooseImg" src="../assets/111111IconColor.svg" />
              <p>{{$t('myChild.childName')}}</p>
              <el-form-item prop="name">
                <el-input :class="changeFlag == 1?'':'errorPass'" type="text" v-model="editForm.nickname" autocomplete="off" :placeholder="$t('myChild.name')"></el-input>
              </el-form-item>
              <p>{{$t('myChild.childBirth')}}</p>
              <el-date-picker
                v-model="editForm.birth_date"
                type="date"
                align="left"
                format="MM/dd/yyyy"
                placeholder="MM/DD/YYYY"
	              :picker-options="pickerOptions">
              </el-date-picker>
            </div>
            <!-- <p class="huo" @click="deletePop"><img style="width:20px;height:20px;" src="../assets/delete.svg" />{{$t('myChild.deleteChild')}}</p> -->
          </div>
          <el-button  type="primary" @click="toEdit()">{{$t('myChild.saveChange')}}</el-button>
        </el-form>
      </div>
    </el-main>

    <div v-if="ShowMessageBox" class="el-message-box__wrapper" style="z-index: 2010;background:rgb(0 0 0 / 30%)">
      <div class="el-message-box">
        <div class="el-message-box__header">
          <div class="el-message-box__title">
            <span>{{$t('myChild.pickAvatar')}}:</span>
          </div>
          <button type="button" class="el-message-box__headerbtn" @click="chooseImg">
            <i class="el-message-box__close el-icon-close"></i>
          </button>
        </div>
        <div class="el-message-box__content">
          <div class="el-message-box__container">
            <div class="el-message-box__message">
                <div class="el-message-box-avatar">
                  <!-- <el-scrollbar> -->
                    <p v-for="(item,i) in getAvatar" :key="i" ><img @click="chooseAvatar(item)" :src="item.url"/><img class="borderAvatar" v-if="item.selected" src="../assets/Ellipse108.svg" /></p>
                  <!-- </el-scrollbar> -->
                </div>    
            </div>
          </div>
        </div>
        <div class="el-message-box__btns">
          <button type="button" class="el-button el-button--default el-button--small el-button--primary" @click="submitAvatar">
            <span>{{$t('myChild.select')}}</span>
          </button>
        </div>
      </div>
    </div>
  </el-container>
</template>

<script>
import { getStore, keys, setStore } from '../store'
export default {
  name: 'addChild',
  data () {
    return {
      childForm: {
        name: '',
        birth_date: ''
      },
      editForm: {
        avatar: '',
        name: '',
        birth_date: ''
      },
      changeFlag: 1,
      changeBrthFlag: 1,
      isshow: true,
      ShowMessageBox: false,
      // 头像列表
      getAvatar: [],
      selectedData: {},
      pickerOptions: {
        disabledDate (time) {
          // 此条为设置禁止用户选择今天之后的日期，包含今天。
          return time.getTime() >= (Date.now())
          // 此条为设置禁止用户选择今天之后的日期，不包含今天。
          // return time.getTime() > (Date.now() - (24 * 60 * 60 * 1000))
        }
      }
    }
  },
  created () {
    if ( getStore(keys.userInfo).status == 0) {
      this.isshow = true
    } else {
         this.$router.push({ path: '/' })
      this.isshow = false
      let cc = JSON.parse(decodeURIComponent(this.$route.query.edit))
      this.editForm = cc
    }
    this.$http.get('/api/getGeadimg').then((res) => {
      if (res.data.code == 200) {
        console.log(res)
        this.getAvatar = res.data.data.data
        this.getAvatar.map((item) => {
          if (item.url == this.editForm.avatar) {
            item.selected = true
            this.selectedData = item
          } else {
            item.selected = false
          }
        })
        // this.$router.push({ path: "/email" });
      } else {
        this.$message({
          message: res.data.msg,
          type: 'warning'
        })
      }
    }).catch((error) => {
      console.log(error) // 请求失败返回的数据
    })
  },
  methods: {
    // back () {
    //   if (this.$route.query.add == 1) {
    //     this.$router.push({ path: '/addChild' })
    //   } else if (this.$route.query.add == 0) {
    //     this.$router.push({ path: '/home/children/addChildren' })
    //   } else {
    //     const h = this.$createElement
    //     this.$msgbox({
    //       title: '',
    //       message: h('p', { style: 'text-align: center' }, [
    //         h('span', null, this.$t('myChild.sureToLeave'))
    //       ]),
    //       showClose: true,
    //       showCancelButton: true,
    //       confirmButtonText: this.$t('myChild.yes'),
    //       cancelButtonText: this.$t('myChild.no'),
    //       confirmButtonClass: 'confirmBtn',
    //       cancelButtonClass: 'borderBtn fr',
    //       beforeClose: (action, instance, done) => {
    //         if (action === 'confirm') {
    //           setTimeout(() => {
    //             done()
    //             if (this.$route.query.one == 1) {
    //               this.$router.push({ path: '/home/children/addChildren' })
    //             } else {
    //               this.$router.push({ path: '/addChild' })
    //             }
    //           }, 1000)
    //         } else {
    //           done()
    //         }
    //       }
    //     }).then(action => {
    //       // this.$message({
    //       //   type: 'info',
    //       //   message: 'action: ' + action
    //       // });
    //     })
    //   }
    // },
    // deletePop () {
    //   const h = this.$createElement
    //   this.$msgbox({
    //     title: '',
    //     message: h('p', { style: 'text-align: center' }, [
    //       h('span', null, this.$t('myChild.sureToDelete') + this.editForm.nickname + this.$t('myChild.sureToWho'))
    //     ]),
    //     showClose: true,
    //     showCancelButton: true,
    //     confirmButtonText: this.$t('myChild.yes'),
    //     cancelButtonText: this.$t('myChild.no'),
    //     confirmButtonClass: 'confirmBtn sim',
    //     cancelButtonClass: 'borderBtn fr sin',
    //     beforeClose: (action, instance, done) => {
    //       if (action === 'confirm') {
    //         setTimeout(() => {
    //           done()
    //           this.deleteStud()
    //         }, 1000)
    //       } else {
    //         done()
    //       }
    //     }
    //   }).then(action => {
    //     // this.$message({
    //     //   type: 'info',
    //     //   message: 'action: ' + action
    //     // });
    //   })
    // },
    addChild () {
      this.$router.push({ path: '/add' })
    },
    chooseImg () {
      this.ShowMessageBox = !this.ShowMessageBox
    },
    toAdd () {
      if (!this.selectedData.url) {
        this.$message({
          message: this.$t('errorprompt.selectAvatar'),
          type: 'warning'
        })
        return false
      }
      if (!this.childForm.birth_date) {
        this.$message({
          message: this.$t('errorprompt.selectBirthday'),
          type: 'warning'
        })
        return false
      }
      if (!this.childForm.name) {
        this.$message({
          message: this.$t('errorprompt.selectName'),
          type: 'warning'
        })
        return false
      }
      this.$http.post('/api/students', {
        avatar: this.selectedData.url,
        birth_date: this.utils.setDate(this.childForm.birth_date),
        nickname: this.childForm.name
      }).then((res) => {
        if (res.data.code == 200) {
          console.log(res)
          this.$http.post('/api/setUserStatus').then((res) => {
        if (res.data.code == 200) {
          console.log(res)
          this.$message({
            message: res.data.msg,
            type: 'success'
          })
          setStore(keys.userInfo, res.data.data)
          this.$router.push({ path: '/home/children/AttendClassNow' })
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      })
        //   if (this.$route.query.add == 1) {
        //     this.$router.push({ path: '/addChild' })    
            // this.$router.push({ path: '/home/children/addChildren' })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    chooseAvatar (avatarItem) {
      this.getAvatar.map((item) => {
        if (item.id == avatarItem.id) {
          item.selected = true
        } else {
          item.selected = false
        }
      })
      this.$forceUpdate()
    },
    submitAvatar () {
      this.ShowMessageBox = !this.ShowMessageBox
      this.getAvatar.map((item) => {
        if (item.selected) {
          this.editForm.avatar = item.url
          this.selectedData = item
        }
      })
    },
    deleteStud () {
      this.$http.post('/api/students/studentid/delete', {
        student_sn: this.editForm.student_sn
      }).then((res) => {
        if (res.data.code == 200) {
          console.log(res)
          if (this.$route.query.one == 1) {
            this.$router.push({ path: '/allChild' })
          } else {
            this.$router.push({ path: '/addChild' })
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    toEdit () {
      if (!this.editForm.avatar) {
        this.$message({
          message: this.$t('errorprompt.selectAvatar'),
          type: 'warning'
        })
        return false
      }
      if (!this.editForm.birth_date) {
        this.$message({
          message: this.$t('errorprompt.selectBirthday'),
          type: 'warning'
        })
        return false
      }
      if (!this.editForm.nickname) {
        this.$message({
          message: this.$t('errorprompt.selectName'),
          type: 'warning'
        })
        return false
      }
      this.$http.post('/api/students/edit', {
        avatar: this.editForm.avatar,
        nickname: this.editForm.nickname,
        birth_date: this.utils.setDate(this.editForm.birth_date),
        student_sn: this.editForm.student_sn
      }).then((res) => {
        if (res.data.code == 200) {
          console.log(res)
          if (this.$route.query.one == 1) {
            this.$router.push({ path: '/home/children/addChildren' })
          } else {
            this.$router.push({ path: '/addChild' })
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .indexhome{
    width: 1200px;
    height:auto!important;
    margin: 0 auto;
  }
  .el-header{
      width: 1200px;
      height:auto!important;
      padding: 20px 0 0;
      font-family: Sofia Pro-Regular;
      font-size: 20px;
      font-weight: 400;
      text-align: left;
      color: #353643;
      .logo {
        width: 227px;
        height: 50px;
        img{
          width:100%;
          height:100%;
        }
      }
      p {
        width: 227px;
        margin-top:5px;
        text-align: center;
      }
  }
  .el-main{
    overflow: inherit;
    padding:0;
    h3{
      font-size: 20px;
      font-family: Sofia Pro-Bold;
      font-weight: 700;
      color: #353643;
      margin-bottom:10px;
      margin-top: 56px;
    }
    p{
      font-size: 18px;
      font-family: Sofia Pro-Regular;
      color: #424347;
    }
    .rules_form{
        // width: 62%;
        max-width: 592px;
        margin:180px auto 0;
        .el-form {
            width: 100%;
            height:100%;
            display: flex;
            flex-direction: column;
            background: #fff;
           
            border-radius: 10px;
           

            .addForm{
              // width:440px;
              // margin: 0 auto 0 auto;
              .addFormList{
                text-align: center;
                p{
                  text-align: left;
                  margin-bottom: 4px;
                  font-family: 'Sofia Pro';
                  font-style: normal;
                  font-weight: 500;
                  font-size: 14px;
                  line-height: 20px;
                  font-feature-settings: 'salt' on;
                  color: #111827;
                 
                }
                .changetop{
                  text-align: center;
                }
                  img{
                    // width:56px;
                    // height:56px;
                    width: 115px;
                    height:115px;
                    cursor: pointer;
                    margin-bottom: 57px;
                    // margin:12px 0 24px 0;
                  }
                  .editBtn{
                    width:24px;
                    height:24px;
                    // margin:10px;
                    margin-left: 16px;
                  }
                  /deep/ .el-form-item{
                    margin-bottom: 20px;
                    .el-form-item__content{
                      display: flex;
                      margin:0!important;
                      .el-input{
                        border: 1px solid #D1D5DB;
                        box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
                        border-radius: 6px;
                      }
                      .errorPass{
                        border-bottom: 1px solid #fc424c;
                      }
                      .el-input__inner {
                        -moz-appearance: none;
                        width:100%;
                        height: 40px;
                        // height: 50px;
                        border:none;
                        background: none;
                        font-size: 16px;
                        color: #353643;
                        font-family: Sofia Pro-Regular;
                        letter-spacing: 0px;
                        outline: 0;
                        padding:0 40px 0 0;
                        border-radius: 0;
                      }
                      .el-form-item__error{
                        // margin-top:7px;
                        font-size: 14px;
                        color: #fc424c;
                        font-family: Sofia Pro-Regular;
                        width: max-content;
                      }
                    }
                  }

              }
            }

            .huo {
              font-size: 16px;
              font-family: Sofia Pro-Bold;
              font-weight: 700;
              text-decoration: underline;
              text-align: LEFT;
              color: #ff6440;
              cursor: pointer;
              margin-top:10px;
              display: flex;
              align-items: center;
              img{
                margin-right:10px;
              }
            }
            button{
              // width: 190px;
              // height: 40px;
              width: 100%;
              height: 50px;
              // background: #ff6440;
              // border-radius: 4px;
              background: #4B4EFC;
             border-radius: 32px;
              border: 1px solid #4B4EFC;
              color: #fff;
              font-style: normal;
              font-weight: 500;
              font-size: 18px;
              font-family: Sofia Pro-Bold;
              margin: 48px auto 0 auto;
              // box-shadow: 0px 1px 6px 1px rgba(81,124,255,0.20), 0px 1px 6px 1px rgba(81,124,255,0.20);
            }
            .borderBtn{
                width:auto;
                height: 40px;
                background: #ffffff;
                border: 2px solid #ff6440;
                border-radius: 7px;
                font-size: 14px;
                font-family: Sofia Pro-Bold;
                font-weight: 700;
                color: #ff6440;
                margin: 0 20px;
                &:hover{
                  background: #ffffff;
                  border: 2px solid #ff6440;
                  font-size: 14px;
                  font-family: Sofia Pro-Bold;
                  font-weight: 700;
                  color: #ff6440;
                }
            }
                input{
                  width:345px;
                  height: 50px;
                  border:none;
                  background: none;
                  font-size: 18px;
                  color: #353643;
                  font-family: Sofia Pro-Regular;
                  letter-spacing: 0px;
                }
                input:focus {
                  outline: none;
                }

          }
        }

  }
  // 日历
.addFormList{
  /deep/.el-date-editor{
    .el-input__inner{
    width: 100%;
    }
  }
} 
/deep/ .el-date-editor{
  .el-input__inner{
    width: 100%;
  }
    width:100%;
    height:40px;
    border: 1px solid #D1D5DB;
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
    border-radius: 6px;
    input,span{
      line-height: 35px;
    }
  input{
    border:none;
    width: 100%;
    text-align: left;
    font-family: Sofia Pro-Regular;
    padding:0;
  }
  .el-range-separator{
    color:#979797;
    font-size: 14px;
    font-family: Sofia Pro-Regular;
  }
  .el-icon-date,.el-input__icon,.el-range__close-icon{
    display: none;
  }

}

.el-message-box{
  background: #ffffff;
  max-height: fit-content !important;
}
.el-message-box__btns button{
  width: 310px;
  height: 50px;
  border-radius: 50px;
  background: #4B69FE;
  border-radius: 50px;
  border: 1px solid #4B69FE;
}
.el-message-box__content{
  margin-left: 70px;
  margin-top: 27px;
  font-weight: bold;
}

.el-scrollbar {

height: 100%;

}
.el-message-box__btns button{
  font-weight: bold;
  font-size: 24px;
}
</style>


// WEBPACK FOOTER //
// src/components/sinadd.vue